(() => {
  // --- スクロール連動ヘッダー（常に追従、スクロール時に背景フェードイン） ---
  const header = document.querySelector('.header');
  if (header) {
    const SCROLLED_THRESHOLD = 8;
    let ticking = false;

    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > SCROLLED_THRESHOLD);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  // --- ハンバーガーメニュー開閉 ---
  const toggle = document.querySelector('[data-header-toggle]');
  const nav = document.querySelector('[data-header-nav]');

  if (toggle && nav) {
    const setState = (open) => {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      setState(!nav.classList.contains('is-open'));
    });

    // メニュー内のリンクをタップしたら閉じる
    nav.addEventListener('click', (event) => {
      const target = event.target;
      if (target && target.closest('a')) {
        setState(false);
      }
    });

    // メニュー外をクリック/タップしたら閉じる
    document.addEventListener('click', (event) => {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(event.target) || toggle.contains(event.target)) return;
      setState(false);
    });

    // Escキーで閉じる
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        setState(false);
        toggle.focus();
      }
    });
  }

  // --- Cookie 同意バナー ---
  (function setupCookieNotice() {
    const notice = document.querySelector('[data-cookie-notice]');
    if (!notice) return;
    const STORAGE_KEY = 'reboot_cookie_consent';
    try {
      if (localStorage.getItem(STORAGE_KEY)) return; // 同意済み or 拒否済みは表示しない
    } catch (e) {
      // localStorage が使えない環境（プライベートブラウジング等）は表示する
    }
    // 少し遅延して表示（離脱防止のため初見から一呼吸おく）
    setTimeout(() => {
      notice.hidden = false;
    }, 1200);

    const hide = (value) => {
      notice.hidden = true;
      try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* ignore */ }
    };

    const acceptBtn = notice.querySelector('[data-cookie-accept]');
    const declineBtn = notice.querySelector('[data-cookie-decline]');
    if (acceptBtn) acceptBtn.addEventListener('click', () => hide('accept:' + Date.now()));
    if (declineBtn) declineBtn.addEventListener('click', () => hide('decline:' + Date.now()));
  })();

  // --- 商品ページ：プレゼント用チェック + 注文全体ギフトメッセージ ---
  (function setupProductGiftOption() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    const checkbox = form.querySelector('[data-gift-checkbox]');
    const fields = form.querySelector('[data-gift-fields]');
    const messageInput = form.querySelector('[data-gift-message]');
    if (!checkbox || !fields || !messageInput) return;

    const GIFT_ATTR = 'ギフトメッセージ';
    const GIFT_PROP = 'プレゼント用';

    const setFieldsVisible = (visible) => {
      fields.hidden = !visible;
      messageInput.disabled = !visible;
    };

    checkbox.addEventListener('change', () => {
      setFieldsVisible(checkbox.checked);
    });

    fetch('/cart.js')
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        const existing = cart && cart.attributes && cart.attributes[GIFT_ATTR];
        if (existing) {
          messageInput.value = existing;
        }
      })
      .catch(() => { /* ignore */ });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const variantId = form.querySelector('[name="id"]').value;
      const isGift = checkbox.checked;
      const message = messageInput.value.trim();

      const item = {
        id: parseInt(variantId, 10),
        quantity: 1,
      };

      if (isGift) {
        item.properties = { [GIFT_PROP]: 'はい' };
      }

      const buttons = form.querySelectorAll('button[type="submit"]');
      buttons.forEach((btn) => { btn.disabled = true; });

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });

        if (!addRes.ok) {
          throw new Error('add_failed');
        }

        if (isGift && message) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { [GIFT_ATTR]: message } }),
          });
        }

        window.location.href = '/cart';
      } catch (e) {
        buttons.forEach((btn) => { btn.disabled = false; });
        window.alert('カートへの追加に失敗しました。時間をおいて再度お試しください。');
      }
    });
  })();

  const applyDiscountButton = document.querySelector('[data-apply-discount]');
  const referralInput = document.querySelector('#referral-code');
  const applyDiscount = () => {
    if (!referralInput) return;
    const code = referralInput.value.trim();
    if (!code) return;
    window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
  };

  if (applyDiscountButton && referralInput) {
    applyDiscountButton.addEventListener('click', applyDiscount);
    referralInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount();
      }
    });
  }

  // --- TOP Hero スライダー ---
  (function setupHeroSlider() {
    const root = document.querySelector('[data-hero-slider]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const prevBtn = root.querySelector('[data-hero-prev]');
    const nextBtn = root.querySelector('[data-hero-next]');
    const track = root.querySelector('[data-hero-track]');
    if (slides.length < 2) return;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;

    let autoplayMs = parseInt(root.dataset.autoplay, 10);
    if (Number.isNaN(autoplayMs) || autoplayMs < 1000) autoplayMs = 5000;

    let timer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    const lockTrackHeight = () => {
      if (!track) return;
      let maxH = 0;
      const savedIndex = index;

      slides.forEach((slide) => {
        slide.style.position = 'relative';
        slide.style.visibility = 'hidden';
        slide.style.opacity = '0';
        slide.style.pointerEvents = 'none';
        slide.classList.remove('is-active');
      });

      slides.forEach((slide, i) => {
        slides.forEach((s, j) => {
          s.style.display = j === i ? 'block' : 'none';
        });
        maxH = Math.max(maxH, slide.offsetHeight);
      });

      slides.forEach((slide, i) => {
        slide.style.position = '';
        slide.style.visibility = '';
        slide.style.opacity = '';
        slide.style.pointerEvents = '';
        slide.style.display = '';
        slide.classList.toggle('is-active', i === savedIndex);
      });

      track.style.minHeight = `${maxH}px`;
    };

    const setSlide = (nextIndex, userTriggered = false) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('aria-label', `${i + 1} / ${slides.length}`);

        const mediaLink = slide.querySelector('.hero-slider__media-link');
        if (mediaLink) {
          if (isActive) {
            mediaLink.removeAttribute('tabindex');
          } else {
            mediaLink.setAttribute('tabindex', '-1');
          }
        }
      });

      dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (userTriggered) {
        restartAutoplay();
      }
    };

    const next = (userTriggered = false) => setSlide(index + 1, userTriggered);
    const prev = (userTriggered = false) => setSlide(index - 1, userTriggered);

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      timer = setInterval(() => next(false), autoplayMs);
    };

    const restartAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => prev(true));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => next(true));
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.dataset.heroDot, 10);
        if (!Number.isNaN(target)) {
          setSlide(target, true);
        }
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) {
        startAutoplay();
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev(true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        next(true);
      }
    });

    root.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
        touchDeltaX = 0;
        stopAutoplay();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchmove',
      (event) => {
        touchDeltaX = event.changedTouches[0].screenX - touchStartX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      () => {
        const threshold = 48;
        if (touchDeltaX > threshold) {
          prev(true);
        } else if (touchDeltaX < -threshold) {
          next(true);
        } else {
          restartAutoplay();
        }
        touchStartX = 0;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    window.addEventListener('resize', lockTrackHeight);
    window.addEventListener('load', lockTrackHeight);

    setSlide(index, false);
    lockTrackHeight();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      startAutoplay();
    }
  })();
})();
